import React from "react";
import LoginHeader from "../../Modules/Login/LoginHeader";
import Footer from "../../Modules/Common/footer";
import { formatter } from "../../Modules/Common/commonUtils";
import { Link } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useCheckoutSuccessState } from "./checkout-success.state";

export function CheckoutSuccess() {
  const { date, time, catererName, caterCash, orderNo, onNewOrder, onViewOrder, onAddToCalendar, loading } =
    useCheckoutSuccessState();

  if (loading) {
    return (
      <>
        <LoginHeader />
        <div className="order-confirm-screen">
          <div className="container-fluid h-100">
            <div className="row h-100">
              <div className="col-lg-5 col-md-6 valign" style={{ background: "#F5F5F5" }}>
                <div className="ocs-img d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                  <CircularProgress />
                </div>
              </div>
              <div className="col-lg-7 col-md-6 valign">
                <div className="ocs-text d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                  <div className="text-center">
                    <CircularProgress />
                    <p className="mt-3">Loading your order details...</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // Check if we have order data
  const hasOrderData = catererName && date && time;

  return (
    <>
      <LoginHeader />
      <div className="order-confirm-screen">
        <div className="container-fluid h-100">
          <div className="row h-100">
            <div className="col-lg-5 col-md-6 valign" style={{ background: "#F5F5F5" }}>
              <div className="ocs-img ">
                <img
                  style={{ cursor: "pointer" }}
                  src={"../assets/images/orderConfirmed.svg"}
                  className="img-fluid"
                  alt="img"
                />
              </div>
            </div>
            <div className="col-lg-7 col-md-6 valign">
              <div className="ocs-text">
                <h1 className="h1">Thank You for Your Order!</h1>
                <div className="mb-2">
                  {orderNo && (
                    <p className="mb-2">
                      <strong>Order Number: #{orderNo}</strong>
                    </p>
                  )}
                  {hasOrderData ? (
                    <>
                      <p>
                        Your order has been placed with
                        <b className="ms-1">{catererName}</b> for{" "}
                        <b>
                          {date} at {time}.
                        </b>
                      </p>
                      <Button
                        className="saveBtn mt-2 mb-2"
                        variant="outlined"
                        color="primary"
                        startIcon={<CalendarTodayIcon />}
                        onClick={onAddToCalendar}>
                        Add to Calendar
                      </Button>
                    </>
                  ) : (
                    <p>
                      Your order has been successfully placed! You will receive an email confirmation shortly.
                    </p>
                  )}
                  <p>You will receive an email once the order is confirmed by the caterer. </p>
                </div>
                {hasOrderData && caterCash > 0 && (
                  <div>
                    <p>
                      {`With the completion of this order you will earn ${formatter.format(
                        +caterCash,
                      )} in CaterCash!`}
                      &nbsp;<Link to={"/CaterCash"}>Check Your CaterCash Balance</Link>
                    </p>
                  </div>
                )}
                <Button
                  className="saveBtn me-3 mt-4"
                  variant="outlined"
                  color="primary"
                  onClick={onNewOrder}>
                  Home
                </Button>
                <Button
                  className="saveBtn me-3 mt-4"
                  variant="outlined"
                  color="primary"
                  onClick={onViewOrder}>
                  View order
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
